var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-data-table", {
        staticStyle: { "white-space": "nowrap" },
        attrs: {
          headers: _vm.headers,
          items: _vm.values,
          "hide-default-header": _vm.empty,
          height: _vm.values.length > 7 ? 32 * 7 + 32 + 16 : undefined,
          "item-key": "none",
          "disable-pagination": "",
          "hide-default-footer": "",
          dense: "",
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function () {
              return [
                _c(
                  "v-toolbar",
                  { attrs: { flat: "", dense: "" } },
                  [
                    _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                    _c("v-divider", {
                      staticClass: "mx-2",
                      attrs: { inset: "", vertical: "" },
                    }),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ma-2",
                        attrs: { small: "", color: "primary" },
                        on: { click: _vm.row_create },
                      },
                      [_vm._v("Add")]
                    ),
                    _c("v-spacer"),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "item.active",
            fn: function ({ item }) {
              return [
                _c("div", { attrs: { align: "center" } }, [
                  _vm._v(_vm._s(item.active ? "ON" : "OFF")),
                ]),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_update(item)
                      },
                    },
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_remove(item)
                      },
                    },
                  },
                  [_vm._v("mdi-delete")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("r-store-bundle-dialog", { ref: "dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }